import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
	DKLabel,
	DKButton,
	DKCheckMark,
	DKExpandableWrapper,
	DKSpinner,
	showLoader,
	removeLoader,
} from "deskera-ui-library";
import {
	fetchModuleAccessControl,
	selectModuleAccessControl,
} from "../../Redux/Slices/ModuleAccessControlSlice";
import ModuleAccessControlService from "./ModuleAccessControlService";
import { LeftMenuUpdate } from "../menu/LeftMenuService";

const ModuleAccessControl = (props) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const accessResponse = useSelector(selectModuleAccessControl);
	const [accessData, setAccessData] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		if (Array.isArray(accessResponse)) {
			setAccessData(accessResponse);
			setIsLoading(false);
		}
	}, [accessResponse]);

	const updateAccessControl = (scope, module) => {
		if (scope && module) {
			setAccessData((prevState) => {
				return [...prevState].map((state) => {
					const s = { ...state };
					if (s.id === scope.id) {
						s.modules = [...s.modules].map((m) => {
							const i = { ...m };
							if (i.id === module.id) {
								i.selected = !m.selected;
							}
							return i;
						});
					}

					return s;
				});
			});
		}
	};

	const saveModuleAccessControl = () => {
		showLoader();

		const payload = {
			data: JSON.stringify([...accessData])
		};
		ModuleAccessControlService.save(payload).then(
			async (response) => {
				ModuleAccessControlService.data = response.modules;
				try {
					await dispatch(fetchModuleAccessControl());
					LeftMenuUpdate.sendMessage(true);
					props.onClose();
				} catch (error) {}
				removeLoader();
			},
			(error) => {
				removeLoader();
			}
		);
	};

	return (
		<div className="transparent-background">
			<div
				className="popup-window"
				style={{
					padding: 0,
					overflow: "hidden",
					maxWidth: "450px",
					boxShadow: "none",
				}}
			>
				<div className="parent-width" style={{ height: "53.5vh" }}>
					<div className="row p-h-xl pt-xl pb-m align-items-start">
						<div className="mr-m">
							<DKLabel text={t("Module Access Control")} className="fs-l fw-b" />
							<DKLabel
								text="Restrict module access to all users or employees only"
								className="mt-xs text-gray"
							/>
						</div>
						<div className="ml-auto d-flex">
							<DKButton
								title={t("CANCEL")}
								className="border-radius-m bg-gray1 border-m"
								onClick={() => {
									props.onClose();
								}}
							/>
							<DKButton
								title={t("SAVE")}
								className="bg-app text-white ml-s"
								onClick={() => {
									saveModuleAccessControl();
								}}
							/>
						</div>
					</div>
					<div
						className="custom-scroll"
						style={{
							overflowY: "auto",
							height: "calc(100% - 112px)",
							margin: "0 24px",
						}}
					>
						<div
							style={{
								marginRight: "1px",
							}}
						>
							{isLoading && (
								<div style={{ marginTop: "calc(50% - 40px)" }}>
									<DKSpinner />
								</div>
							)}
							{!isLoading && accessData.map((scope, idx) => (
								<DKExpandableWrapper
									title={scope.name}
									className="border-s"
									headerStyle={{
										backgroundColor: "#f4f4f6",
										padding: "10px 15px 8px 12px",
									}}
									style={{
										width: "calc(100% - 2px)",
										marginTop: idx !== 0 ? 5 : 0,
									}}
								>
									{scope.modules.map((module) => (
										<div className="row p-h-m justify-content-between">
											<div className="p-v-s">
												<DKLabel text={module.name} />
											</div>
											<div className="p-v-s w-20">
												<DKCheckMark
													className="justify-content-end"
													isSelected={module.selected}
													color={"bg-button"}
													onClick={() => {
														updateAccessControl(scope, module);
													}}
												/>
											</div>
										</div>
									))}
								</DKExpandableWrapper>
							))}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ModuleAccessControl;
